/** 站台識別（沿用舊站）。 */
export const SITE = {
  name: '大媒體新聞網',
  tagline: '大媒體娛樂文創&產業平台',
  lang: 'zh-TW',
  locale: 'zh_TW',
  timezone: 'Asia/Taipei',
} as const;

/** LINE Today feed 收錄的分類 slug（舊站 ID 4,7,17,75,76）。 */
export const LINE_TODAY_CATEGORY_SLUGS = [
  'art',
  'industry',
  'cultural-creative-industries',
  'life',
  'travel',
] as const;

/** LINE Today feed 每次輸出篇數與推薦篇數。 */
export const LINE_TODAY = {
  maxArticles: 20,
  recommendCount: 3,
  thumbnailSize: [630, 340] as const,
  expireDays: 30,
} as const;

export const OAUTH_PROVIDERS = ['line', 'yahoo', 'google'] as const;
export type OAuthProvider = (typeof OAUTH_PROVIDERS)[number];

export const ARTICLE_STATUSES = ['draft', 'in_review', 'scheduled', 'published'] as const;
export type ArticleStatus = (typeof ARTICLE_STATUSES)[number];
